import {Record} from 'immutable';

import {makeReducer, match} from 'web-app/util/redux';

import * as Types from '../types';
import * as Actions from './actions';

interface ImportModalStateProps {
    modalState: Types.ImportModalState;
    remainingRows?: Types.SpreadsheetData;
    results?: Types.ImportResult[];
}

export class ImportModalState extends Record<ImportModalStateProps>({
    modalState: Types.ImportModalState.Hidden,
    remainingRows: undefined,
    results: undefined,
}) {}

export default makeReducer<ImportModalState>(
    [
        match(Actions.reset, () => new ImportModalState()),
        match(Actions.updateImportModalState, (state, {payload: {payload}}) => {
            if (payload.modalState === Types.ImportModalState.ImportFinished) {
                return state.merge({
                    modalState: payload.modalState,
                    remainingRows: payload.remainingRows,
                    results: payload.results,
                });
            } else {
                return state.merge({
                    modalState: payload.modalState,
                });
            }
        }),
    ],
    new ImportModalState(),
);
